import React from 'react';
import type { User } from '@typings/api';

interface UserAvatarProps {
  user: User;
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ user, className = '' }) => {
  const getInitials = (username: string) => {
    return username
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getLevelColor = (level: number) => {
    if (level >= 5) return 'bg-purple-600';
    if (level >= 3) return 'bg-blue-600';
    return 'bg-gray-600';
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {user.avatar ? (
        <img
          src={user.avatar}
          alt={user.username}
          className="w-8 h-8 rounded-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : (
        <div
          className={`${getLevelColor(user.level)} w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium`}
        >
          {getInitials(user.username)}
        </div>
      )}

    </div>
  );
};